import React, { useContext } from "react";
import { ContentContext } from "context/Content";
import { toast } from "react-hot-toast";
import SecondaryButton from "components/Buttons/SecondaryButton";

function EmbedCodeField(props) {
    const { state } = useContext(ContentContext);

    const getEmbedCodeFor = (data) => {
        if (data.attachment && data.attachment.extension == "gif") {
            return `<video id="video-${
                data.attachment.uuid
            }" autoplay playsinline muted loop preload="auto" style="width:100%" data-setup="{}"><source src="${data.attachment.imgix_url.replace(
                "sized-1000x1000",
                "original"
            )}?fm=mp4" type="video/mp4"></video>`;
        } else if (data.attachment && data.attachment.extension == "mp4") {
            return `<video id="video-${data.attachment.uuid}" controls preload="auto" style="width:100%" data-setup="{}"><source src="${data.attachment.original_url}" type="video/mp4"></video>`;
        } else if (
            data.attachment &&
            (data.attachment.type == "video" ||
                data.attachment.type == "quicktime")
        ) {
            return `<video id="video-${data.attachment.uuid}" controls preload="auto" poster="${data.attachment.imgix_url}" style="width:100%" data-setup="{}"><source src="${data.attachment.original_url}" type="video/mp4"></video>`;
        } else if (data.attachment && data.attachment.type == "youtube") {
            return `<iframe width="560" height="315" src="https://www.youtube.com/embed/${data.attachment.base_name}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;
        } else if (data.attachment && data.attachment.type == "pdf") {
            return `<object data="${data.attachment.original_url}" type="application/pdf" width="100%" height="100%"><iframe src="${data.attachment.original_url}" style="border: none;" width="100%" height="100%">This browser does not support PDFs. Please download the PDF to view it: <a href="${data.attachment.original_url}">Download PDF</a></iframe></object>`;
        } else {
            return `<image id="image-${data.attachment.uuid}" src="${data.attachment.imgix_url}?fm=auto&w=1000&dpr=2" alt="" />`;
        }
    };

    const requestClipboardWrite = (data) => {
        const code = getEmbedCodeFor(data);

        navigator.clipboard.writeText(code).then(() => {
            toast.success("Copied to clipboard");
        });
    };
    if (state.loading) {
        return (
            <div>
                <div className="mt-1 h-9 w-full animate-pulse rounded bg-gray-300 text-gray-300"></div>
            </div>
        );
    }

    if (state.content.type !== "media") {
        return (
            <div>
                <SecondaryButton
                    className="hidden w-full sm:block"
                    onClick={() => {}}
                    disabled={true}
                >
                    Copy Embed Code
                </SecondaryButton>
            </div>
        );
    }

    return (
        <div>
            <SecondaryButton
                className="hidden w-full sm:block"
                onClick={requestClipboardWrite.bind(
                    null,
                    state.content && state.content.uuid ? state.content : null
                )}
            >
                Copy Embed Code
            </SecondaryButton>
        </div>
    );
}

export default EmbedCodeField;
